import { useIntl } from 'react-intl';
import { mdiInformation } from '@mdi/js';
import CollapsibleSnackBar from '../CollapsibleSnackBar/CollapsibleSnackBar';
import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import { MAX_SCALE } from 'client/pages/MapPage/layers/constants';
import { DESKTOP } from 'client/utils/constants/GDS/js/devices';
import { useMapScale } from 'client/pages/MapPage/hooks/useMapScale';
import useDeviceType from 'client/utils/helpers/DeviceType/useDeviceType';
import { useSelector } from 'react-redux';

const AOIMarkUpSnackBar = () => {
    const intl = useIntl();
    const deviceType = useDeviceType();
    const scale = useMapScale();
    const aoiSource = useSelector(state => state.aoi?.source);

    const aoiExtent = aoiSource?.getExtent();
    const isAoiExist = aoiExtent.some(value => value !== null && isFinite(value));

    const visible = scale > MAX_SCALE && deviceType !== DESKTOP && !isAoiExist;
    return <SnackBar visible={visible} variant="info" data-testid='mobileMarkUp.snackBar'>
        <CollapsibleSnackBar
            icon={mdiInformation}
            label={ intl.formatMessage({ id: 'mobileMarkUp.notification.label' })}
            data-testid="mobileMarkUp.alert"
        >
            {intl.formatMessage({ id: 'mobileMarkUp.alert' })}
        </CollapsibleSnackBar>
    </SnackBar>;
};

export default AOIMarkUpSnackBar;
